/* src/app/components/admin/accounts/account-edit/account-edit.component.scss */
.row {
  padding-bottom: 10px;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: underline;
}
.mat-mdc-form-field-error {
  margin-top: -10px;
}
a.disabled {
  color: rgba(0, 0, 0, 0.87);
  pointer-events: none;
  cursor: not-allowed;
  text-decoration: none;
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
}
/*# sourceMappingURL=account-edit.component.css.map */
